module.exports = __webpack_public_path__ + "img/dementia-friendly.d8b82df8.png";